import store from '../store'
import Trabalhos from '../pages/Trabalhos.vue'

export default [
    {
        path: '/trabalhos/branding',
        name: 'branding',
        component: Trabalhos,
        beforeEnter: (to, from, next) => {
            store.dispatch('taxo_trabalhos/turnOffAllTags')
            store.dispatch('turnTag', 'Branding')
            next()
        }
    },
]
